import { liveOpsPathResources } from "./Pages/liveOpsPaths";
import { taskPathResources } from "./Pages/TasksPage/Pages/taskPaths";

export const LIVE_OPS_SUB_NAV_TITLES = {
    [liveOpsPathResources.tasks]: "Tasks",
    [taskPathResources.upcoming]: "Upcoming Tasks",
    [taskPathResources.past]: "Past Tasks",
    [liveOpsPathResources.agents]: "Agents",
    [liveOpsPathResources.queues]: "Queues",
    [liveOpsPathResources.recentActivity]: "Recent Activity",
} as const;

export const LIVE_OPS_PAGE_DESCRIPTIONS = {
    [liveOpsPathResources.tasks]: "Task management system for agent activities and follow-ups.",
    [taskPathResources.upcoming]: "Task management system for agent activities and follow-ups.",
    [taskPathResources.past]: "Recent task activity and status monitoring.",
    [liveOpsPathResources.agents]: "Agent management system for user configuration and performance monitoring.",
    [liveOpsPathResources.queues]: "Call queue management system for handling inbound and outbound communications.",
    [liveOpsPathResources.recentActivity]: "Real-time feed of system events and user actions across the platform.",
} as const;

// Spotlight-only copy. Inside the Live Ops nav "Queues" is unambiguous, but in global search it
// competes with the Orchestration queue configuration page, so Spotlight spells out the difference.
// "Send Event" isn't a nav item/page at all — it's an action that opens a modal on Recent
// Activity — so it only ever exists as spotlight-only copy.
export const LIVE_OPS_SPOTLIGHT_TITLES = {
    [liveOpsPathResources.queues]: "Queue Performance",
    sendEvent: "Send Event",
} as const;

export const LIVE_OPS_SPOTLIGHT_DESCRIPTIONS = {
    [liveOpsPathResources.queues]: "A real-time view of key metrics for each of your queues",
    sendEvent: "Trigger a custom event.",
} as const;
